/**
 * Public contact and social URLs — single source of truth for Header + Contact.
 * Forkers: replace with your own values.
 */
export const siteConfig = {
  displayName: 'Darshan Lal',
  contactEmail: 'darshanmandhwani12@gmail.com',
  phoneDisplay: '(+971) 569544696',
  phoneTel: '+971569544696',
  locationLine:
    'Dubai UAE, I am open to relocation for better opportunities if required.',
  social: {
    linkedin: 'https://www.linkedin.com/in/darshan-lal-402b1b13a/',
    github: 'https://github.com/darshan82',
    facebook: 'https://www.facebook.com/darshan123696',
  },
  resumeDownloadFilename: 'Darshan_Lal_CV.pdf',
};
